import { type Distance, DistanceUnit } from "@/schemas/location/distance";

export function formatDistance(distance: Distance): Distance {
  let { value } = distance;
  const { unit } = distance;

  // Convert all distances to kilometers for consistent processing
  if (unit === DistanceUnit.METERS) {
    value = value / 1000;
  } else if (unit === DistanceUnit.MILES) {
    value = value * 1.60934;
  } else if (unit === DistanceUnit.FEET) {
    value = value * 0.0003048;
  }

  if (value >= 0.5) {
    // For distances 1 km and above
    if (value >= 100) {
      // Round to nearest km for large distances
      return { value: Math.round(value), unit: DistanceUnit.KILOMETERS };
    } else {
      // Use one decimal place for distances between 1 and 100 km
      return { value: Number(value.toFixed(1)), unit: DistanceUnit.KILOMETERS };
    }
  } else {
    // Convert to meters for distances less than 1 km
    const valueInMeters = value * 1000;
    if (valueInMeters < 1) {
      // For extremely small distances, round up to 1 meter
      return { value: 1, unit: DistanceUnit.METERS };
    } else if (valueInMeters < 10) {
      // Use one decimal place for distances less than 10 meters
      return {
        value: Number(valueInMeters.toFixed(1)),
        unit: DistanceUnit.METERS,
      };
    } else {
      // Round to nearest meter for distances between 10 and 500 meters
      return { value: Math.round(valueInMeters), unit: DistanceUnit.METERS };
    }
  }
}

function getUnitString(distance: Distance): string {
  const { value, unit } = distance;
  if (unit === DistanceUnit.METERS) {
    return value === 1 ? "meter" : "meters";
  }
  return unit;
}

export function formatDistanceStr(distance: Distance | null): string {
  if (distance === null) {
    return "Not available";
  } else {
    const output = formatDistance(distance);
    const unitString = getUnitString(output);
    return output.value + " " + unitString;
  }
}
